/**
 * Sidebar theme definitions for the system appearance settings.
 * Administrators can select one of these themes to apply to all users.
 */

export interface SidebarTheme {
  id: string;
  name: string;
  gradientFrom: string;
  gradientVia: string;
  gradientTo: string;
  textMode: 'light' | 'dark';
}

export interface LoginTheme {
  gradient_from: string;
  gradient_via: string;
  gradient_to: string;
}

export const SIDEBAR_THEMES: SidebarTheme[] = [
  { 
    id: 'purple_blue', 
    name: 'Roxo Azulado', 
    gradientFrom: '#3D1A5C', 
    gradientVia: '#5B4B9E', 
    gradientTo: '#3B82F6',
    textMode: 'light'
  },
  { 
    id: 'blue_green', 
    name: 'Azul Esverdeado', 
    gradientFrom: '#1E3A5F', 
    gradientVia: '#2E5A6F', 
    gradientTo: '#10B981',
    textMode: 'light'
  },
  { 
    id: 'green_teal', 
    name: 'Verde Institucional', 
    gradientFrom: '#064E3B', 
    gradientVia: '#047857', 
    gradientTo: '#14B8A6',
    textMode: 'light'
  },
  { 
    id: 'red_orange', 
    name: 'Vermelho Laranja', 
    gradientFrom: '#7F1D1D', 
    gradientVia: '#B91C1C', 
    gradientTo: '#F97316',
    textMode: 'light'
  },
  { 
    id: 'gray_blue', 
    name: 'Cinza Corporativo', 
    gradientFrom: '#1F2937', 
    gradientVia: '#374151', 
    gradientTo: '#3B82F6',
    textMode: 'light'
  },
  { 
    id: 'navy_gold', 
    name: 'Marinho Dourado', 
    gradientFrom: '#1E3A5F', 
    gradientVia: '#2C4A7C', 
    gradientTo: '#F59E0B',
    textMode: 'light'
  },
  { 
    id: 'dark_purple', 
    name: 'Roxo Escuro', 
    gradientFrom: '#1A1A2E', 
    gradientVia: '#16213E', 
    gradientTo: '#6366F1',
    textMode: 'light'
  },
  { 
    id: 'ocean_blue', 
    name: 'Azul Oceano', 
    gradientFrom: '#0C4A6E', 
    gradientVia: '#0369A1', 
    gradientTo: '#38BDF8',
    textMode: 'light'
  },
];

export const DEFAULT_SIDEBAR_THEME = SIDEBAR_THEMES[0]; // purple_blue

export const DEFAULT_LOGIN_THEME: LoginTheme = {
  gradient_from: '#3D1A5C',
  gradient_via: '#5B4B9E',
  gradient_to: '#3B82F6'
};

export const DEFAULT_TEXT_MODE: 'light' | 'dark' = 'light';

/**
 * Get theme by ID, fallback to default if not found
 */
export function getThemeById(themeId: string | null | undefined): SidebarTheme {
  if (!themeId) return DEFAULT_SIDEBAR_THEME;
  return SIDEBAR_THEMES.find(t => t.id === themeId) || DEFAULT_SIDEBAR_THEME;
}

/**
 * Generate CSS gradient string from theme colors
 */
export function generateGradient(from: string, via: string, to: string): string {
  return `linear-gradient(180deg, ${from}, ${via}, ${to})`;
}
